import MuiTable, { TableProps as MuiTableProps } from '@mui/material/Table';
import MuiTableBody, { TableBodyProps as MuiTableBodyProps } from '@mui/material/TableBody';
import MuiTableCell, { TableCellProps as MuiTableCellProps } from '@mui/material/TableCell';
import MuiTableContainer, { TableContainerProps as MuiTableContainerProps } from '@mui/material/TableContainer';
import MuiTableFooter, { TableFooterProps as MuiTableFooterProps } from '@mui/material/TableFooter';
import MuiTableHead, { TableHeadProps as MuiTableHeadProps } from '@mui/material/TableHead';
import MuiTableRow, { TableRowProps as MuiTableRowProps } from '@mui/material/TableRow';

import React from 'react';

interface TableProps extends MuiTableProps {
	striped?: boolean;
	disableLastBorder?: boolean;
}
interface TableBodyProps extends MuiTableBodyProps {}
interface TableFooterProps extends MuiTableFooterProps {}
interface TableCellProps extends MuiTableCellProps {}
interface TableContainerProps extends MuiTableContainerProps {
	component?: React.ElementType;
}
interface TableHeadProps extends MuiTableHeadProps {}
interface TableRowProps extends MuiTableRowProps {}

export const Table = ({ striped, disableLastBorder, sx, ...props }: TableProps) => {
	return (
		<MuiTable
			{...props}
			sx={[
				{
					...(striped ? { '& > tbody > tr:nth-of-type(odd)': { bgcolor: 'background.paper-colour' } } : {}),
					...(disableLastBorder ? { '& > tbody > tr:last-child > td, & > tbody > tr:last-child > th': { borderBottomWidth: 0 } } : {})
				},
				...(Array.isArray(sx) ? sx : sx ? [sx] : [])
			]}
		/>
	);
};

export const TableBody = (props: TableBodyProps) => {
	return <MuiTableBody {...props} />;
};

export const TableFooter = (props: TableFooterProps) => {
	return <MuiTableFooter {...props} />;
};

export const TableCell = (props: TableCellProps) => {
	return <MuiTableCell {...props} />;
};

export const TableContainer = React.forwardRef<HTMLDivElement, TableContainerProps>((props, ref) => {
	return <MuiTableContainer ref={ref} {...props} />;
});

export const TableHead = (props: TableHeadProps) => {
	return <MuiTableHead {...props} />;
};

export const TableRow = React.forwardRef<HTMLTableRowElement, TableRowProps>((props, ref) => {
	return <MuiTableRow ref={ref} {...props} />;
});
